// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".single-product .product-image[data-v-946b8d62]{min-height:376px}.single-product.has-separator[data-v-946b8d62]{border-bottom:2px;border-color:rgba(31,21,9,.05);border-color:rgba(31,21,9,var(--tw-border-opacity));border-style:solid;--tw-border-opacity:0.05;padding-bottom:2.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
